import React, { useEffect, useState } from 'react';
import '../App.css';

const formatDate = (timestamp, includeTime = false) => {
    if (!timestamp) return '—';
    const date = new Date(timestamp * 1000);
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };

    if (includeTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.hour12 = false; // optional: use 24-hour format
    }

    return date.toLocaleString('en-US', options);
};


const StudioUsers = () => {
    const [stats, setStats] = useState({
        dau: null,
        wau: null,
        mau: null,
        total: null,
    });

    const [proUsers, setProUsers] = useState([]);
    const [names, setNames] = useState({});
    const [loading, setLoading] = useState(true);
 // pubkey => display_name or name

    useEffect(() => {
    setTimeout(async () => {
        setLoading(true);
        try {
            const e = await window.nostr.signEvent({
                created_at: Math.floor(Date.now() / 1000),
                kind: 10000222,
                tags: [],
                content: "i want in",
            });

            const statsResponse = await fetch("https://admin.primal.net/api2", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ event_from_user: e, request: ["pro_user_stats", {}] }),
            });
            const statsData = await statsResponse.json();
            if (statsData && typeof statsData === 'object') {
                setStats({
                    dau: statsData.dau,
                    wau: statsData.wau,
                    mau: statsData.mau,
                    total: statsData.total,
                });
            }

            const usersResponse = await fetch("https://admin.primal.net/api2", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ event_from_user: e, request: ["pro_users", {}] }),
            });
            const usersData = await usersResponse.json();
            if (usersData?.users) {
                setProUsers(usersData.users);
                const pubkeys = usersData.users.map(user => user.pubkey);
                await fetchDisplayNames(pubkeys); // Wait for names to load
            }
        } catch (error) {
            console.error("Fetch error:", error);
        } finally {
            setLoading(false); // Always hide loader
        }
    }, 500);
}, []);


    const fetchDisplayNames = async (pubKeys) => {
    const payload = JSON.stringify(["user_infos", { pubkeys: pubKeys }]);
    try {
        const response = await fetch("https://dev.primal.net/api", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
        });

        if (response.ok) {
            const data = await response.json();
            const nameMap = {};
            if (Array.isArray(data)) {
    const nameMap = {};

    data.forEach(user => {
        try {
            if (!user?.content) return; // skip if content is missing or empty
            const parsed =
                typeof user.content === 'string'
                    ? JSON.parse(user.content)
                    : user.content;

            const nameToDisplay =
                parsed.display_name || parsed.displayName || parsed.name || user.pubkey;

            nameMap[user.pubkey] = nameToDisplay;
        } catch (err) {
            console.error("Error parsing user content:", err, user);
            nameMap[user.pubkey] = user.pubkey; // fallback
        }
    });
            console.log("Resolved name map:", nameMap);
            setNames(nameMap); }
        } else {
            console.error("Error fetching names:", response.statusText);
        }
    } catch (error) {
        console.error("Error fetching names:", error);
    }
};

    return (
    <div className="MainBody">
        <div className="UMTitle">studio users</div>

        {loading ? (
            <div className="loader"><span></span></div>
        ) : (
            <>
                {/* Premium Stats */}
                <div className="PremiumCardZone">
                    <div className="PremiumCardsContainer">
                        <div className="PremiumCard">
                            <div className="PremiumCardTitle">DAU</div>
                            <div className="PremiumCardValue">{stats.dau ?? '...'}</div>
                        </div>
                        <div className="PremiumCard">
                            <div className="PremiumCardTitle">WAU</div>
                            <div className="PremiumCardValue">{stats.wau ?? '...'}</div>
                        </div>
                        <div className="PremiumCard">
                            <div className="PremiumCardTitle">MAU</div>
                            <div className="PremiumCardValue">{stats.mau ?? '...'}</div>
                        </div>
                        <div className="PremiumCard">
                            <div className="PremiumCardTitle">TOTAL</div>
                            <div className="PremiumCardValue">{stats.total ?? '...'}</div>
                        </div>
                    </div>
                </div>

                {/* User Table */}
                <div className="authenticated_table_container">
                    <table className="authenticated_table">
                        <thead>
                            <tr className="table_header">
                                <th>User</th>
                                <th>Last Login</th>
                                <th>Trial Expiration</th>
                                <th>Followers</th>
                            </tr>
                        </thead>
                        <tbody>
                            {proUsers.length === 0 ? (
                                <tr className="table_row">
                                    <td colSpan="4">Loading...</td>
                                </tr>
                            ) : (
                                proUsers.map((user, index) => (
                                    <tr className="table_row" key={index}>
                                        <td>
                                            <a
                                                href={`https://primal.net/p/${user.pubkey}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="user-link"
                                            >
                                                {names.hasOwnProperty(user.pubkey) ? names[user.pubkey] : user.pubkey}
                                            </a>
                                        </td>
                                       <td>{formatDate(user.last_access_at, true)}</td>
                                        <td>{formatDate(user.license_status.valid_until)}</td>
                                        <td>{user.follower_cnt}</td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </>
        )}
    </div>
);
};

export default StudioUsers;
